import {
  CREATE_BOARD_SUCCESS,
  CREATE_BOARD_FAIL,
  GET_BOARDS_LIST_SUCCESS,
  GET_BOARDS_LIST_FAIL,
  FETCH_SLIDES_SUCCESS,
  FETCH_SLIDES_FAIL,
  ADD_SLIDE_SUCCESS,
  ADD_SLIDE_FAIL,
  LOGIN_TO_NOTICE_BOARD_SUCCESS,
  LOGIN_TO_NOTICE_BOARD_FAIL,
  DELETE_SLIDE_SUCCESS,
  DELETE_SLIDE_FAIL,
  UPDATE_SLIDE_SUCCESS,
  UPDATE_SLIDE_FAIL,
  RESET_NOTICE_BOARD_PASSWORD_SUCCESS,
  RESET_NOTICE_BOARD_PASSWORD_FAIL,
  DELETE_BOARD_SUCCESS,
  DELETE_BOARD_FAIL,
  GET_BOARDS_LIST,
} from "./actionTypes";

const INIT_STATE = {
  list: [],
  res: [],
  error: [],
  slides: [],
  loading: false,
  noticeError: [],
};

const NoticeBoard = (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESET_NOTICE_BOARD_PASSWORD_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case RESET_NOTICE_BOARD_PASSWORD_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_BOARD_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case DELETE_BOARD_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_SLIDE_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case DELETE_SLIDE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_SLIDE_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case UPDATE_SLIDE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_SLIDE_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case ADD_SLIDE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case FETCH_SLIDES_SUCCESS:
      return {
        ...state,
        slides: action.payload,
      };
    case FETCH_SLIDES_FAIL:
      return {
        ...state,
        noticeError: action.payload,
      };
    case GET_BOARDS_LIST:
      return {
        ...state,
        loading: true,
      };
    case GET_BOARDS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload,
      };
    case GET_BOARDS_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CREATE_BOARD_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case CREATE_BOARD_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case LOGIN_TO_NOTICE_BOARD_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case LOGIN_TO_NOTICE_BOARD_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return {
        error: [],
        ...state,
      };
  }
};

export default NoticeBoard;
